<div *ngIf="f">
  <input 
      class="form-control"
      type="color" 
      [value]="f.value" 
      [disabled]="f.readOnly || (mode !== 'write')"
      (input)="onInputChange($event)"
  />
</div>
